import React from 'react';
import Badge from '@material-ui/core/Badge';

const SarasBadge = (props)=>{
    return(
        <Badge badgeContent={props.badge}
            anchorOrigin={props.anchorOrigin}
            color={props.color}
            style={props.style}
            className={props.className}
        >
            {props.children}
        </Badge>
    )
}

export default SarasBadge